import { createI18n } from 'vue-i18n'
import zh from '../locales/zh.json'
import en from '../locales/en.json'
import th from '../locales/th.json'

// 获取当前语言（优先从本地存储读取，否则检测浏览器语言，默认中文）
const getLocale = () => {
  const storageLang = localStorage.getItem('lang')
  if (storageLang) return storageLang

  const browserLang = navigator.language.split('-')[0]

  const supportedLangs = ['zh', 'en', 'th']
  return supportedLangs.includes(browserLang) ? browserLang : 'zh'
}

const i18n = createI18n({
  legacy: false, // 必须设置为 false 才能在 Vue 3 中使用 Composition API
  locale: getLocale(), // 当前默认语言
  fallbackLocale: 'en', // 当当前语言找不到对应词条时，回退到英文
  messages: {
    zh,
    en,
    th
  }
})

export default i18n
